export const getWholesalerDisplayName = (type, truncate = false, isDemo = false) => {
    switch (type) {
        case 'bluepax_secondary': {
            if (isDemo)
                return 'Secondary #1';
            if (truncate)
                return 'BluPax';
            return 'BluPax Pharma';
        }
        case 'bloodworth_secondary': {
            if (isDemo)
                return 'Secondary #4';
            if (truncate)
                return 'Bloodworth';
            return 'Bloodworth Wholesale';
        }
        case 'capital_secondary': {
            if (isDemo)
                return 'Secondary #2';
            return 'Capital Drug';
        }
        case 'rx_supply_secondary': {
            if (isDemo)
                return 'Secondary #3';
            if (truncate)
                return 'Rx Supply';
            return 'Prescription Supply';
        }
        case 'keysource_secondary': {
            if (isDemo)
                return 'Secondary #5';
            if (truncate)
                return 'KeySource';
            return 'KeySource USA';
        }
        case 'toprx_secondary': {
            if (isDemo)
                return 'Secondary #6';
            if (truncate)
                return 'TopRx';
            return 'TopRx Pharma';
        }
        case 'auburn_secondary': {
            if (isDemo)
                return 'Secondary #7';
            if (truncate)
                return 'Auburn';
            return 'Auburn Generics';
        }
        case 'ipc_secondary': {
            if (isDemo)
                return 'Secondary #8';
            if (truncate)
                return 'IPC';
            return 'IPC Warehouse';
        }
        case 'quest_secondary': {
            if (isDemo)
                return 'Secondary #10';
            if (truncate)
                return 'Quest';
            return 'Quest Pharmaceutical';
        }
        case 'masters_secondary': {
            if (isDemo)
                return 'Secondary #11';
            if (truncate)
                return 'Masters';
            return 'Masters';
        }
        case 'mckesson_primary': {
            if (isDemo)
                return 'Primary #1';
            return 'McKesson';
        }
        case 'cardinal_primary': {
            if (isDemo)
                return 'Primary #2';
            return 'Cardinal Health';
        }
        case 'kinray_primary': {
            if (isDemo)
                return 'Primary #3';
            return 'Kinray';
        }
        case 'amerisource_primary': {
            if (isDemo)
                return 'Primary #4';
            return 'AmerisourceBergen';
        }
        default:
            return 'Wholesaler Name';
    }
};
export var PrimaryWholesalerName;
(function (PrimaryWholesalerName) {
    PrimaryWholesalerName["MCKESSON"] = "McKesson";
    PrimaryWholesalerName["CARDINAL_HEALTH"] = "Cardinal Health";
    PrimaryWholesalerName["KINRAY"] = "Kinray";
    PrimaryWholesalerName["AMERISOURCE"] = "Amerisource Bergen";
    PrimaryWholesalerName["SMITH_DRUG"] = "Smith Drug";
    PrimaryWholesalerName["LOUISIANA_WHOLESALE"] = "Louisiana Wholesale Drug";
    PrimaryWholesalerName["MUTUAL_DRUG"] = "Mutual Drug Company";
    PrimaryWholesalerName["MORRIS_DICKSON"] = "Morris Dickson";
    PrimaryWholesalerName["API"] = "API";
    PrimaryWholesalerName["OTHER"] = "Other";
})(PrimaryWholesalerName || (PrimaryWholesalerName = {}));
export var SecondaryWholesalerName;
(function (SecondaryWholesalerName) {
    SecondaryWholesalerName["BLUPAX"] = "Blupax";
    SecondaryWholesalerName["CAPITAL"] = "Capital";
    SecondaryWholesalerName["RXSUPPLY"] = "Prescription Supply";
    SecondaryWholesalerName["BLOODWORTH"] = "Bloodworth";
    SecondaryWholesalerName["KEYSOURCE"] = "Keysource";
    SecondaryWholesalerName["TOPRX"] = "TopRx";
    SecondaryWholesalerName["AUBURN"] = "Auburn";
    SecondaryWholesalerName["IPC"] = "IPC";
    SecondaryWholesalerName["QUEST"] = "Quest Pharmaceutical";
    SecondaryWholesalerName["MASTERS"] = "Masters";
})(SecondaryWholesalerName || (SecondaryWholesalerName = {}));
export const mapPrimaryNameToWholesaler = (primaryName) => {
    if (primaryName === PrimaryWholesalerName.MCKESSON) {
        return 'mckesson_primary';
    }
    if (primaryName === PrimaryWholesalerName.AMERISOURCE) {
        return 'amerisource_primary';
    }
    if (primaryName === PrimaryWholesalerName.CARDINAL_HEALTH) {
        return 'cardinal_primary';
    }
    if (primaryName === PrimaryWholesalerName.KINRAY) {
        return 'kinray_primary';
    }
    return undefined;
};
